import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import analytics from "../lib/analytics";

// Fires a GA4 page_view on every React Router navigation (including the first
// load). gtag('config') is set with send_page_view:false so this is the single
// source of page_view events — no duplicates.
export default function RouteAnalytics() {
  const location = useLocation();
  useEffect(() => {
    analytics.pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
